import { Route } from '@angular/router';

import { applicationRouteNames } from '../../app/application-route-names';
import { MpsRoleHelper } from '../../app/helpers/mps-role.helper';
import { MpsUser } from '../../app/models/mps-user.model';
import { MpsIRoutesRules } from '../interfaces/mps-routes-rules.interface';

export class MpsPermissionHelper {
  // Use properties 'forbiddenRoles' or 'allowedRoles' to define user page access.
  // Use property 'forbiddenRoles' to deny access to user having those specifics roles :
  // { routepath: routeNames.home, forbiddenRoles: [RoleHelper.PARTNER] },
  // Use property 'allowedRoles' to give access only to user having those specifics roles :
  // { routepath: routeNames.home, allowedRoles: [RoleHelper.OWNER, RoleHelper.ADMIN, RoleHelper.SUPERADMIN] },

  // Rôles admin global (accès total) et rôles ayant accès aux données de filiale.
  private static readonly ADMIN_ROLES = [MpsRoleHelper.ADMIN, MpsRoleHelper.SUPERADMIN];
  private static readonly SUBSIDIARY_DATA_ROLES = [
    MpsRoleHelper.ADMIN,
    MpsRoleHelper.SUPERADMIN,
    MpsRoleHelper.SUBSIDIARY_ADMIN,
  ];

  static readonly routesRules: MpsIRoutesRules[] = [
    { routepath: applicationRouteNames.home },
    // Section admin : accessible aux admins globaux ET admins de filiale.
    { routepath: applicationRouteNames.administration, allowedRoles: MpsPermissionHelper.SUBSIDIARY_DATA_ROLES },
    // Réservé aux admins globaux.
    { routepath: applicationRouteNames.users, allowedRoles: MpsPermissionHelper.ADMIN_ROLES },
    { routepath: applicationRouteNames.subsidiaries, allowedRoles: MpsPermissionHelper.ADMIN_ROLES },
    { routepath: applicationRouteNames.lokalise, allowedRoles: MpsPermissionHelper.ADMIN_ROLES },
    // Données de filiale : admins globaux + admins de filiale.
    { routepath: applicationRouteNames.contacts, allowedRoles: MpsPermissionHelper.SUBSIDIARY_DATA_ROLES },
    { routepath: applicationRouteNames.reports, allowedRoles: MpsPermissionHelper.SUBSIDIARY_DATA_ROLES },
  ];

  static canUserActivate(user: MpsUser, route: Route) {
    const routeRule = this.routesRules.find((r) => r.routepath === route.path);
    if (routeRule) {
      if (routeRule.forbiddenRoles && routeRule.forbiddenRoles.length > 0) {
        return this.hasNotRole(user, routeRule.forbiddenRoles);
      } else if (routeRule.allowedRoles && routeRule.allowedRoles.length > 0) {
        return this.hasAnyRole(user, routeRule.allowedRoles);
      } else {
        return true;
      }
    }
    return true;
  }

  static isAdmin(user: MpsUser): boolean {
    return user.role !== null && user.isAdmin();
  }

  static hasAnyRole(user: MpsUser, rolesList: string[]) {
    return user.role && rolesList.includes(user.role.code.toUpperCase());
  }

  static hasNotRole(user: MpsUser, rolesList: string[]) {
    return user.role && !rolesList.includes(user.role.code.toUpperCase());
  }
}
